export class EngineSignatureField {
    public name!: string;
    public x!: number;
    public y!: number;
    public width!: number;
    public height!: number;
    public page!: number;
}
